import { render, staticRenderFns } from "./AssignRoles.vue?vue&type=template&id=3cbba5ec&scoped=true&"
import script from "./AssignRoles.vue?vue&type=script&lang=js&"
export * from "./AssignRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbba5ec",
  null
  
)

export default component.exports